import { useEffect, useState } from 'react';
import { IColorVariant, IProductVariant } from '../../../../services/helper/productInterfaces';
import useFavorite from './useFavorite';

export const useProductTile = (variants: IProductVariant[], pageName: string | undefined) => {
  const [productVariant, setProductVariant] = useState<IProductVariant>({} as IProductVariant);
  const { isFavoriteSelected } = useFavorite();

  useEffect(() => {
   if(pageName == 'Favorites') {
      const item = variants.find(variant => isFavoriteSelected(variant.sku));
      if(item) {
        setProductVariant(item);
      }
    } else {
      setProductVariant(variants[0]);
    }
  },[]);

  const onProductTileChange = (colorVariant: IColorVariant) => {
    const variant = variants.find(variant => variant.id === colorVariant.id && variant.sku === colorVariant.sku);
    if (variant) setProductVariant(variant);
  };

  const onFavoriteClick = (isFavorite: boolean) => {
    // TODO: Favorite the product variant
  };

  const getSortedByReleaseDate = () => {
    const retItems = variants.sort((a: any, b: any) => {
      const firstDate: any = new Date(a.releaseDate);
      const secondDate: any = new Date(b.releaseDate);
      return secondDate - firstDate;
    });
    return retItems;
  }

  return {
    productVariant,
    onProductTileChange,
    onFavoriteClick,
    getSortedByReleaseDate
  };
};
